/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Add_RatingInputs */

const en_directory_detail_add_rating = /** @type {(inputs: Directory_Detail_Add_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add rating`)
};

const zh_directory_detail_add_rating = /** @type {(inputs: Directory_Detail_Add_RatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加评分`)
};

/**
* | output |
* | --- |
* | "Add rating" |
*
* @param {Directory_Detail_Add_RatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_add_rating = /** @type {((inputs?: Directory_Detail_Add_RatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Add_RatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_add_rating(inputs)
	return zh_directory_detail_add_rating(inputs)
});
export { directory_detail_add_rating as "directory.detail.add_rating" }